import React from 'react';

const SummaryStats = ({ laps, totalTime, averageLapTime, trackPoints }) => {
    return (
        <div>
            <div className="summary-stats">
                <div className="stat-box">
                    <div className="stat-label">Laps Detected</div>
                    <div className="stat-value">{laps}</div>
                </div>
                <div className="stat-box">
                    <div className="stat-label">Total Time</div>
                    <div className="stat-value">{totalTime}</div>
                </div>
                <div className="stat-box">
                    <div className="stat-label">Avg Lap Time</div>
                    <div className="stat-value">{averageLapTime}</div>
                </div>
            </div>
        </div>
    );
};

export default SummaryStats;
